import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  BackgroundJob,
  BackgroundJobFilters,
  BackgroundJobsPaginatedResponse,
} from "~/types/admin/backgroundJobs";

class AdminBackgroundJobsModule extends HttpFactory {
  async getJobs(
    filters: BackgroundJobFilters = {},
  ): Promise<BackgroundJobsPaginatedResponse<BackgroundJob>> {
    return await this.get(ENDPOINTS.ADMIN.BASE.BACKGROUND_JOBS, filters);
  }

  async getJob(jobId: number): Promise<BackgroundJob> {
    return await this.get(`${ENDPOINTS.ADMIN.BASE.BACKGROUND_JOBS}${jobId}/`);
  }
}

export default AdminBackgroundJobsModule;
